var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardOverviewSaveIcon = function SvgNewcsDashboardOverviewSaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_overview_save_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M224 114h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 513"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_overview_save_icon_svg__a)",
    transform: "translate(-224 -114)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M224.687 128a.69.69 0 0 1-.687-.689v-12.624a.69.69 0 0 1 .687-.688h8.918a.7.7 0 0 1 .5.217l3.705 3.954a.68.68 0 0 1 .186.471v8.671a.69.69 0 0 1-.688.689Zm11.938-1.376v-7.711l-3.316-3.537h-7.934v11.248h1.679v-3.416a.79.79 0 0 1 .789-.789h6.312a.79.79 0 0 1 .789.789v3.416Zm-7.992-.259h4.734V124h-4.734Zm-1.57-6.832v-1.974a.756.756 0 0 1 .756-.756.756.756 0 0 1 .756.756v1.974a.756.756 0 0 1-.756.756.756.756 0 0 1-.757-.756Z",
    "data-name": "\\u8054\\u5408 87"
  }))));
};
export default SvgNewcsDashboardOverviewSaveIcon;